function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("rect", {
  opacity: 0.5,
  y: 0.996,
  width: 64,
  height: 64,
  rx: 12,
  fill: "#B9D7F6",
  fillOpacity: 0.13
});

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  opacity: 0.5,
  y: 108.496,
  width: 72,
  height: 21,
  rx: 4,
  fill: "#B9D7F6",
  fillOpacity: 0.13
});

var _ref3 = /*#__PURE__*/React.createElement("rect", {
  opacity: 0.5,
  y: 143.496,
  width: 152,
  height: 15,
  rx: 4,
  fill: "#B9D7F6",
  fillOpacity: 0.13
});

var _ref4 = /*#__PURE__*/React.createElement("rect", {
  opacity: 0.5,
  y: 163.496,
  width: 128,
  height: 15,
  rx: 4,
  fill: "#B9D7F6",
  fillOpacity: 0.13
});

var _ref5 = /*#__PURE__*/React.createElement("rect", {
  opacity: 0.5,
  y: 199.496,
  width: 64,
  height: 15,
  rx: 4,
  fill: "#B9D7F6",
  fillOpacity: 0.13
});

var _ref6 = /*#__PURE__*/React.createElement("rect", {
  opacity: 0.5,
  y: 219.496,
  width: 112,
  height: 15,
  rx: 4,
  fill: "#B9D7F6",
  fillOpacity: 0.13
});

var SvgCarouselItemPlaceholder = function SvgCarouselItemPlaceholder(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 152,
    height: 237,
    viewBox: "0 0 152 237",
    fill: "none"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6);
};

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTUyIiBoZWlnaHQ9IjIzNyIgdmlld0JveD0iMCAwIDE1MiAyMzciIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxyZWN0IG9wYWNpdHk9IjAuNSIgeT0iMC45OTU4NSIgd2lkdGg9IjY0IiBoZWlnaHQ9IjY0IiByeD0iMTIiIGZpbGw9IiNCOUQ3RjYiIGZpbGwtb3BhY2l0eT0iMC4xMyIvPgo8cmVjdCBvcGFjaXR5PSIwLjUiIHk9IjEwOC40OTYiIHdpZHRoPSI3MiIgaGVpZ2h0PSIyMSIgcng9IjQiIGZpbGw9IiNCOUQ3RjYiIGZpbGwtb3BhY2l0eT0iMC4xMyIvPgo8cmVjdCBvcGFjaXR5PSIwLjUiIHk9IjE0My40OTYiIHdpZHRoPSIxNTIiIGhlaWdodD0iMTUiIHJ4PSI0IiBmaWxsPSIjQjlEN0Y2IiBmaWxsLW9wYWNpdHk9IjAuMTMiLz4KPHJlY3Qgb3BhY2l0eT0iMC41IiB5PSIxNjMuNDk2IiB3aWR0aD0iMTI4IiBoZWlnaHQ9IjE1IiByeD0iNCIgZmlsbD0iI0I5RDdGNiIgZmlsbC1vcGFjaXR5PSIwLjEzIi8+CjxyZWN0IG9wYWNpdHk9IjAuNSIgeT0iMTk5LjQ5NiIgd2lkdGg9IjY0IiBoZWlnaHQ9IjE1IiByeD0iNCIgZmlsbD0iI0I5RDdGNiIgZmlsbC1vcGFjaXR5PSIwLjEzIi8+CjxyZWN0IG9wYWNpdHk9IjAuNSIgeT0iMjE5LjQ5NiIgd2lkdGg9IjExMiIgaGVpZ2h0PSIxNSIgcng9IjQiIGZpbGw9IiNCOUQ3RjYiIGZpbGwtb3BhY2l0eT0iMC4xMyIvPgo8L3N2Zz4K";
export { SvgCarouselItemPlaceholder as ReactComponent };